<!--
 * @Author: Gaho
 * @Date: 2024-02-26 15:35:29
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-17 17:29:38
 * @Description: 
-->
<template>
    <div class="corgiwild-board"
        :class="{ 'board-no-animation': true, 'hide-bg': !showBg }"
    >
        <img :src="imgSource"
            class="corgiwild-bg"
            alt=""
        />
        <div class="corgiwild-wrapper">
            <div class="corgiwild-wrapper-decor" 
                :style="{opacity: (showBg || cardFullHeight) ? 1 : 0}"
            > 
                <img
                    class="corgiwild-wrapper-arrow"
                    src="@/assets/imgs/casino/corgiwild/arrow.webp"
                    alt=""
                />
                <img
                    class="corgiwild-wrapper-arrow corgiwild-wrapper-arrow-left"
                    src="@/assets/imgs/casino/corgiwild/arrow-left.webp"
                    alt=""
                />
                <div class="corgiwild-wrapper-break corgiwild-wrapper-break-left">
                    <img
                        class="corgiwild-wrapper-break-img"
                        src="@/assets/imgs/casino/corgiwild/break.svg"
                        alt=""
                    />
                </div>
                <div class="corgiwild-wrapper-break corgiwild-wrapper-break-right">
                    <img
                        class="corgiwild-wrapper-break-img"
                        src="@/assets/imgs/casino/corgiwild/break.svg"
                        alt=""
                    />
                </div>
            </div>
            <!-- 
                ↑箭头装饰物 
            -->
            <div class="corgiwild-wrapper-slot"
                :style="{
                    'opacity': iSectionOpacity,
                    'max-height': slotBlockHeight + 'px',
                    '--section-width': sectionWidth ? `${sectionWidth}px` : '33.33%',
                }"
            >
                <div class="corgiwild-wrapper-sections"
                    ref="sections"
                >
                    <div
                        class="corgiwild-wrapper-section"
                        ref="section"
                        v-for="(section, index) in sections"
                        :key="index"
                        :class="{ 'corgiwild-wrapper-section-roll': rollingSlot }"
                        :style="{
                            'transform': `translate3d(0, ${sectionsScroll[index]}px, 0)`,
                        }"
                    >
                        <CorgiWildCard
                            v-for="(item, ind) in section"
                            :key="`${index}:${ind} key:${item.key}`"
                            :name="`${index}:${ind} id:${item.id}`"
                            :section="item.id"
                            :index="ind"
                            :isWin="winCards[index]"
                        />
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useSettingsStore from '~/stores/settings';
// components
import CorgiWildCard from '../cards/index.vue';
// types & mocks
import { corgiWildConfig } from '../../data';
import bg from '@/assets/imgs/casino/corgiwild/bg.webp';
import bgSm from '@/assets/imgs/casino/corgiwild/bg-sm.webp';

export default defineComponent({
    name: 'board',
    components: {
        CorgiWildCard,
    },
    props: {
        isAnimate: {
            // 是否开启动画效果
            type: Boolean,
            default: false,
        },
        showBg: {
            // false--投注详情弹框，true=用于游戏舞台 
            type: Boolean,
            default: true,
        },
        resResult: {
            // 投注结果（接口请求后的返回结果） 
            type: Object,
            default: () => ({}),
        },
        musicControler: {
            // 音效
            type: Object,
            default: () => ({}),
            require: false,
        },
    },
    data() {
        return {
            imgSource: null,

            cardHeight: 0, // 卡片高度
            cardMargin: 0, // 卡片间距
            winCards: [false, false, false],
            cardCount: 39, // 总共的卡片数量
            sectionMargin: 0,
            sectionWidth: 0,
            sectionsScroll: [0, 0, 0], // 卡片滚动位置
            settingStore: useSettingsStore(),
            rollingSlot: false, // 是否开启列表滚动动画
            localIndex: 0, // index-key
            lastResults: [],
            sections: [], // 卡片列表（3大列） 
            isMobile: false, // 是否移动端
            aniTimer: null,
            sectionTimer: null,
            abortController: null,
            gameTimestamp: '',
        };
    },
    computed: {
        isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
        // 卡片实际高度
        cardFullHeight() {
            // ↓ 实测在最小360屏幕下最终宽度为 95px 
            return this.cardHeight + this.cardMargin;
        },
        // 视图区域max-height
        slotBlockHeight() {
            if (!this.cardFullHeight) {
                return 300; 
            }
            return this.cardFullHeight * 3 - this.cardMargin + 5;
        },
        iSectionOpacity(){
            if (this.showBg) return 1;
            if (this.cardFullHeight && (this.gameTimestamp == this.resResult?.timestamp)){
                return 1;
            }
            return 0;
        },
        // 每一列的高度
        sectionHeight() {
            return this.cardFullHeight * this.cardCount - this.cardMargin;
        },
        // 每列默认位置
        defaultPosition() {
            return Math.round(this.sectionHeight - this.cardFullHeight * 4 + this.cardMargin) * -1;
        },
        defaultLosePosition() {
            return this.defaultPosition - this.cardFullHeight / 2;
        },
        endLosePosition() {
            return (this.cardFullHeight / 2) * -1;
        },
        // 根据下注结果计算滚动位置
        scrollByResult() {
            return this.resResult.rollNumber.map((item) => (item === 0 ? this.endLosePosition : 0));
        },
        returnByResult() {
            return this.resResult.rollNumber.map((item) =>
                item === 0 ? this.defaultLosePosition : this.defaultPosition,
            );
        },
    },
    watch: {
        sectionWidth(newVal) {
            if (!newVal) return;
            // console.log('sectionWidth -->', newVal); 
            const cardClass = this.showBg
                ? '.corgiwild-wrapper-card'
                : '.corgiwild-board-popup .corgiwild-wrapper-card';
            const card = document.querySelector(cardClass);
            // 卡片高度
            this.cardHeight = newVal;
            // 卡片间距
            this.cardMargin = Number(getComputedStyle(card).marginBottom.split('px')[0]);
            // 初始化滚动位置
            this.sectionsScroll = [
                this.defaultPosition,
                this.defaultPosition,
                this.defaultPosition,
            ];
            !this.showBg && this.handleAnimation();
        },
        // ↓ 此方法是游戏专用，窗口模式不用此方法（已关停，改为父组件手动调用 handleAnimation()) 于  2025.05.07 18:40:35 星期三 
        // resResult: {
        //     handler(newVal, oldVal) {
        //         if (
        //             this.showBg && 
        //             newVal &&
        //             Object.keys(newVal).length &&
        //             JSON.stringify(newVal) !== JSON.stringify(oldVal)
        //         ) {
        //             console.log('已经收到下发的游戏结果↓\n', deepCopy(newVal)); 
        //             this.handleAnimation();
        //         }
        //     },
        // },
    },
    created(){
        if (import.meta.client){
            this.handleInitData();
        }
    },
    async mounted() {
        await this.$nextTick();
        this.handleResize();
        await this.$nextTick();
        this.abortController = new AbortController();
        window.addEventListener('resize', this.handleResize, {
            signal: this.abortController.signal,
        });
    },
    unmounted() {
        this.aniTimer && clearTimeout(this.aniTimer);
        this.sectionTimer && clearTimeout(this.sectionTimer);
        this.abortController?.abort();
    },
    methods: {
        handleInitData() {
            const t01 = Date.now();
            this.sections = corgiWildConfig.sectors.map((sector) =>
                sector.map((item) => ({
                    id: item,
                    key: ++this.localIndex,
                })),
            );
            console.log('handleInitData(); used ms:', Date.now() - t01);
        },
        getIMobile() {
            this.isMobile = document.body.getBoundingClientRect().width <= 576;
            this.imgSource = this.isMobile ? bgSm : bg;
        },
        async handleResize() {
            // await this.$nextTick(); 
            this.getIMobile();
            this.setDefaultProp();
        },
        /**
         * 设置默认属性
         */
        setDefaultProp() {
            this.sectionTimer = setTimeout(
                () => {
                    const sectionClass = this.showBg
                        ? '.corgiwild-wrapper-section'
                        : '.corgiwild-board-popup .corgiwild-wrapper-section';
                    const sectionsDomClass = this.showBg
                        ? '.corgiwild-wrapper-sections'
                        : '.corgiwild-board-popup .corgiwild-wrapper-sections';
                    const section = document.querySelector(sectionClass);
                    const sectionsDom = document.querySelector(sectionsDomClass);
                    if (section && sectionsDom) {
                        this.sectionMargin = Number(
                            getComputedStyle(section).marginRight.split('px')[0],
                        );
                        this.sectionWidth = Math.floor(
                            (sectionsDom.getBoundingClientRect().width - this.sectionMargin * 2) /
                                3,
                        );
                    }
                },
                this.showBg ? 0 : 300,
            );
        },
        /**
         * 获取随机类型游戏卡片
         */
        getRandomCards() {
            let num = 0;
            const timestamp = String(this.resResult.timestamp);
            for (let i = 0; i < timestamp.length; i++) {
                const unicode = timestamp.charCodeAt(i);
                num = (num << 5) - num + unicode;
            }
            num = String(Math.abs(num)) as any;
            if (import.meta.env.DEV_MODE){
                // console.trace('getRandomCards() excuted'); 
                console.log('timestamp 🚩', timestamp); 
                console.log('rollNumber 01 🚩', this.resResult.rollNumber.join('-')); 
                console.log('String(num).length < 12 🚩', String(num).length < 12, num); 
                if (String(num).length >= 12) console.error('> 12 !!!'); 
            }
            if (String(num).length < 12) {
                num = num + num;
                const aResult = this.resResult.rollNumber.map((item, index) =>
                    String(num)
                        .slice(4 * index, 4 * index + 4)
                        .split('')
                        .map((ele) => ({
                            id: (parseInt(ele, 16) % 6) + 1,
                            key: ++this.localIndex,
                        })),
                );
                return aResult; 
            }
        },
        /**
         * 获取赢分对应的卡片
         */
        getWinCards() {
            const winCombination = [...this.resResult.winCombination];
            this.resResult.rollNumber.forEach((item, index) => {
                const ind = winCombination.findIndex((ele) => ele === String(item));
                if (ind >= 0) {
                    winCombination.splice(ind, 1);
                    this.winCards[index] = true;
                }
            });
        },
        /**
         * 设置下注结果
         */
        setResult() {
            const randomCards = this.getRandomCards();
            console.log('randomCards ------------------'); 
            console.log(deepCopy(randomCards));  
            this.sections.forEach((section, index) => {
                if (this.resResult.rollNumber[index] !== 0) {
                    randomCards[index][1] = {
                        id: this.resResult.rollNumber[index],
                        key: ++this.localIndex,
                    };
                }
                section.splice(0, 4);
                section.unshift(...randomCards[index]);
                // console.log(`列${index} ⭕`, section.map(cur=>cur.id).join(', ')); 
            });
            this.getWinCards();
        },
        /**
         * 获取保存上一轮游戏结果
         */
        generateSections() {
            this.sections.forEach((section, index) => {
                section.splice(0, 4);
                section.push(...this.lastResults[index]);
            });
        },
        /**
         * 列表滚动动画效果
         */
        handleAnimation() {
            const t01 = Date.now();
            // if (import.meta.dev) console.trace('handleAnimation()');  
            if (this.showBg) {
                this.settingStore.game.corgiwild.fast
                    ? this.musicControler?.oAudio.FWildRollFast.toPlay()
                    : this.musicControler?.oAudio.FWildRoll.toPlay();
            }
            const delay = this.settingStore.game.corgiwild.fast
                ? (this.isSafari ? 1000 : 500)
                : 2000;
            this.winCards = [false, false, false];
            this.setResult();
            this.rollingSlot = true;
            this.sectionsScroll = this.scrollByResult;
            this.lastResults = [
                this.sections[0].slice(0, 4),
                this.sections[1].slice(0, 4),
                this.sections[2].slice(0, 4),
            ];
            // ↓ 便于父组件调用 
            const {promise, resolve} = createPromise();
            if (!this.showBg) {
                this.generateSections();
                this.rollingSlot = false;
                this.sectionsScroll = this.returnByResult;
                setTimeout(()=>{
                    this.gameTimestamp = this.resResult.timestamp;
                }, 100);
                this.handleResize();
                resolve(); // 窗口模式，不需要 setTimeout 
            } else {
                this.aniTimer && clearTimeout(this.aniTimer);
                this.aniTimer = setTimeout(() => {
                    this.generateSections();
                    this.rollingSlot = false;
                    this.sectionsScroll = this.returnByResult;
                    setTimeout(resolve, 100);
                }, delay);
            }
            console.log('handleAnimation() used ms:', Date.now() - t01); 
            return promise;
        },
    },
});
</script>

<style lang="scss">
.corgiwild-board {
    border-radius: 10px;
    padding: 60px 12px 0;
    position: relative;
    width: auto;

    @media (max-width: 576px) {
        padding: 10px 12px;
    }
    @media (max-width: 460px) {
        border-radius: 0;
        margin-inline: -16px;
    }
    .corgiwild-bg {
        border-radius: 10px;
        bottom: 0;
        display: block;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        // background: url(@/assets/imgs/casino/corgiwild/bg-sm.webp) no-repeat center;
        // @media screen and (max-height: 740px) and (max-width: 576px) {
        //     display: none;
        // }
        @media (max-width: 576px) {
            display: none;
        }
    }

    .corgiwild-bg-xs {
        display: none;

        @media screen and (max-height: 740px) and (max-width: 576px) {
            display: block;
        }
    }

    .corgiwild-wrapper {
        position: relative;
        z-index: 5;
        width: 100%;

        .corgiwild-wrapper-decor {
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;

            .corgiwild-wrapper-arrow {
                animation: pulse-arrow 2s linear infinite;
                position: absolute;
                right: -13px;
                top: 50%;
                transform: translateY(-50%) scale(1);

                @media (max-width: 576px) {
                    right: -12px;
                }
            }

            .corgiwild-wrapper-arrow-left {
                // display: none;
                left: -12px;
                right: auto;

                @media (max-width: 576px) {
                    display: block;
                }
            }

            .corgiwild-wrapper-break {
                background: linear-gradient(
                    180deg,
                    #fff0,
                    #ffffff80 22.15%,
                    #fff 38.66%,
                    #fff 57.23%,
                    #ffffff80 75.14%,
                    #fff0
                );
                height: 357px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 3px;
                z-index: 3;

                @media (max-width: 576px) {
                    height: 280px;
                }
            }

            .corgiwild-wrapper-break-left {
                right: 67%;
            }

            .corgiwild-wrapper-break-right {
                right: 32.2%;
            }

            .corgiwild-wrapper-break-img {
                animation: pulse-break 2s linear infinite;
                height: 33px;
                left: 0;
                max-width: none;
                position: absolute;
                top: 50%;
                transform: translate(-44.5%, -50%) scale(1);
                width: 27px;
            }
        }

        .corgiwild-wrapper-slot {
            overflow: hidden;
            padding-top: 5px;
            position: relative;
            width: 100%;
            min-height: 280px;

            .corgiwild-wrapper-sections {
                display: flex;
                justify-content: space-between;
                position: relative;
                width: 100%;

                .corgiwild-wrapper-section {
                    margin-right: 20px;
                    transition-duration: 0s;
                    width: 33.33%; 
                    max-width: var(--section-width); 
                    &:last-child {
                        margin: 0;
                    }

                    @media (max-width: 576px) {
                        margin-right: 14px;
                    }
                }
                .corgiwild-wrapper-section-roll {
                    &:first-child {
                        transition-duration: 1s;
                    }
                    &:nth-child(2) {
                        transition-duration: 1.5s;
                    }
                    &:nth-child(3) {
                        transition-duration: 2s;
                    }
                }
            }
        }
    }
}
// 跟原站点同步 取消游戏面板的动画效果
.board-no-animation {
    .corgiwild-wrapper-break-img {
        animation: none !important;
    }
}
.hide-bg {
    // @media (max-width: 576px) {
        padding: 10px 12px;
    // }
    .corgiwild-bg,
    .corgiwild-bg-imgs {
        display: none;
    }
}



@keyframes pulse-arrow {
    0% {
        transform: translateY(-50%) scale(1);
    }

    50% {
        transform: translateY(-50%) scale(1.2);
    }

    to {
        transform: translateY(-50%) scale(1);
    }
}

@keyframes pulse-break {
    0% {
        transform: translate(-44.5%, -50%) scale(1);
    }

    50% {
        transform: translate(-44.5%, -50%) scale(1.2);
    }

    to {
        transform: translate(-44.5%, -50%) scale(1);
    }
}
</style>